/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Admin_Export_Usage_ExactInputs */



/**
* | output |
* | --- |
* | "Exactly {amount} € — the file prints every amount as stored, with no rounding." |
*
* @param {Admin_Export_Usage_ExactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_usage_exact = /** @type {((inputs: Admin_Export_Usage_ExactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Usage_ExactInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Genau ${i?.amount} € — die Datei enthält jeden Betrag wie gespeichert, ohne Rundung.`)
	return /** @type {LocalizedString} */ (`Exactly ${i?.amount} € — the file prints every amount as stored, with no rounding.`)
});